import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Drop static prerender head tags; react-helmet (React 19 native tags) owns them at runtime,
// so the rendered DOM has exactly one canonical/title/description/hreflang set.
document.querySelectorAll("head link[data-pr], head meta[data-pr][property], head meta[data-pr][name^='twitter:']").forEach((el) => el.remove());
// Static <title>/description stay as fallback until the route renders its own.
new MutationObserver(() => {
  ["title", "meta[name='description']"].forEach((sel) => {
    const stat = document.head.querySelector(`${sel}[data-pr]`);
    if (stat && document.head.querySelector(`${sel}:not([data-pr])`)) stat.remove();
  });
}).observe(document.head, { childList: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Fade out the branded splash once React has painted the real UI (removes the
// brief flash of the static prerender fallback).
(function hideSplash() {
  const sp = document.getElementById("pr-splash");
  if (!sp) return;
  const remove = () => {
    sp.classList.add("pr-hide");
    setTimeout(() => sp.parentNode && sp.parentNode.removeChild(sp), 500);
  };
  requestAnimationFrame(() => requestAnimationFrame(remove));
  setTimeout(remove, 4000); // safety net
})();

